import React, { useState } from 'react';
import { toast } from 'sonner';
import { Lock, LockOpen } from '@phosphor-icons/react';
import { isAppLockEnabled, setAppLockEnabled } from './AppLock';
import SettingRow from './shell/SettingRow';

/**
 * The screen-lock row in More. Per-device on purpose: a lock belongs to
 * the phone you carry, not to the account, so turning it off on a desktop
 * leaves it on for the phone.
 */
const AppLockToggle = () => {
  const [enabled, setEnabled] = useState(isAppLockEnabled);

  const onSelect = (e) => {
    e.preventDefault();
    const next = !enabled;
    setAppLockEnabled(next);
    setEnabled(next);
    toast(next
      ? 'This device will ask for your password after a minute away'
      : 'Screen lock turned off on this device');
  };

  return (
    <SettingRow
      icon={enabled ? Lock : LockOpen}
      label="Screen lock"
      hint="Asks for your password after a minute away. This device only."
      trailing={enabled ? 'On' : 'Off'}
      onSelect={onSelect}
      aria-pressed={enabled}
      data-testid="app-lock-toggle"
    />
  );
};

export default AppLockToggle;
